"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPairs = exports.groupBy = void 0;
var groupBy = function (keyFn) { return function (ts) {
    return ts.reduce(function (groups, t) {
        var key = keyFn(t);
        var val = groups[key];
        groups[key] = val || [];
        groups[key].push(t);
        return groups;
    }, {});
}; };
exports.groupBy = groupBy;
var toPairs = function (obj) {
    return Object.keys(obj).reduce(function (accum, key) { return __spreadArray(__spreadArray([], accum), [[key, obj[key]]]); }, []);
};
exports.toPairs = toPairs;
